import { render, staticRenderFns } from "./footer-btn.vue?vue&type=template&id=05b11324&"
import script from "./footer-btn.vue?vue&type=script&lang=js&"
export * from "./footer-btn.vue?vue&type=script&lang=js&"
import style0 from "./footer-btn.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports